import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import axios from 'axios';
import CategoryCard from '../category-card/CategoryCard';
import AreaCard from '../area-card/AreaCard';
import "./categoryGrid.scss"
import Alphabets from '../alphabets/Alphabets';

const CategoryGrid = props => {
  const [categories, setCategories] = useState([]);
  const [areas, setAreas] = useState([]);
  useEffect(() => {
    const getCategories = async () => {
      const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/categories.php`);
      setCategories(response.data.categories);
      // console.log(response.data.categories);
    }

    const getAreas = async () => {
      const response = await axios.get('https://www.themealdb.com/api/json/v1/1/list.php?a=list');
      setAreas(response.data.meals);
    }
    
    props.category === 'c' ? getCategories() : getAreas();
  }, [props.category, props.alphabet]);

  return (
    <div className='category-grid'>
      {
        props.category === 'c' &&
        categories.map((category, index) => (
          <CategoryCard id={category.idCategory} image={category.strCategoryThumb} title={category.strCategory} key={index} />
        ))
      }
      {
        props.category === 'a' &&
        areas.map((area, index) => (
          <AreaCard area={area.strArea} key={index} />
        ))
      }
      {
        props.category === 'alphabets' &&
        <Alphabets />
      }
    </div>
  )
}

CategoryGrid.propTypes = {
  category: PropTypes.string.isRequired
}

export default CategoryGrid